import React from 'react';

import { BaseStatusTextProps } from '../../types/BaseStatusTextProps';
import { Icon } from '../Icon/Icon';
import { Layout } from '../Layout/Layout';
import { TruncateText } from '../Text/subcomponents/TruncateText';
import { Text } from '../Text/Text';
import { Tooltip } from '../Tooltip/Tooltip';

export const StatusText = ({
  icon,
  iconColor = 'inherit',
  iconSpacing,
  iconTooltip,
  shouldTruncate,
  status,
  text,
  textColor = 'inherit',
  tooltip,
  variant,
}: BaseStatusTextProps) => {
  let iconSize: 'l' | 's' | 'm' = 'm';
  if (variant === 'title') {
    iconSize = 'l';
  } else if (variant === 'tiny' || variant === 'tiny-bold') {
    iconSize = 's';
  }

  const TextComponent = shouldTruncate ? TruncateText : Text;

  return (
    <Tooltip tooltip={tooltip}>
      <Layout align="center" color={`status.${status}`} preset={iconSpacing}>
        {icon && (
          <Icon
            color={iconColor}
            icon={icon}
            size={iconSize}
            tooltip={iconTooltip}
          />
        )}
        <TextComponent color={textColor} variant={variant}>
          {text}
        </TextComponent>
      </Layout>
    </Tooltip>
  );
};
